module.exports = __webpack_public_path__ + "assets/adpoly-facility-labs-bulk-upload-template.29d83d5a.xlsx";